function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1224 3.45065L58.3554 7.94588C62.0793 8.32433 65.8317 8.33027 69.5568 7.96363L106.803 4.29769C117.622 3.23279 127 11.7329 127 22.6046C127 32.7641 118.764 41 108.605 41H90.2941C89.0271 41 88 39.9729 88 38.7059C88 30.6097 77.5888 27.3104 72.9257 33.929L70.3675 37.56C69.3131 39.0565 67.3233 39.5576 65.686 38.7389L45.1368 28.4643C39.0747 25.4333 31.9525 25.3726 25.8397 28.2998C15.2522 33.3699 3 25.6526 3 13.9137V13.5C3 7.51748 8.17051 2.84579 14.1224 3.45065Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgTrack11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 44,
    viewBox: "0 0 130 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack11);
export default __webpack_public_path__ + "static/media/track11.e57bf8ac.svg";
export { ForwardRef as ReactComponent };